import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const addUser = async (ownerData) => {
  const formData = new FormData();
  formData.append("UserName", ownerData.UserName);
  formData.append("UserId", ownerData.UserId);
  formData.append("UserRoleId", ownerData.UserRoleId);
  formData.append("EmailId", ownerData.EmailId);
  formData.append("MobileNo", ownerData.MobileNo);
  formData.append("Password", ownerData.Password);
  formData.append("ConfirmPassword", ownerData.ConfirmPassword);
  console.log("profileImage", ownerData.ProfileImageFile);
  if (ownerData.ProfileImageFile) {
    formData.append("ProfileImageFile", ownerData.ProfileImageFile);
  }
  const response = await axiosInstance.post("admin/user", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
    },
  });
  return response.data;
};

export const getUsers = async () => {
  return await axiosInstance.get("admin/user", { headers });
};

export const blockUser = async (userId) => {
  return await axiosInstance.patch(`admin/user/${userId}/block`, { headers });
};
export const unBlockUser = async (userId) => {
  return await axiosInstance.patch(`admin/user/${userId}/unblock`, { headers });
};

export const deleteUser = async (userid) => {
  return await axiosInstance.delete(`admin/user/${userid}`, { headers });
};

export const updateUser = async (payload) => {
  return await axiosInstance.put("admin/user", payload, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
    },
  });
};

export const fetchUserById = async (userid) => {
  const response = await axiosInstance.get(`admin/user/${userid}`, { headers });
  return response.data.result;
};

export const changePassword = async (data) => {
  return await axiosInstance.patch("admin/user/change-password", data, {
    headers,
  });
};

export const createPassword = async (data) => {
  return await axiosInstance.patch("admin/user/update-password", data, {
    headers,
  });
};

export const fetchUserProfile = async () => {
  return await axiosInstance.get("admin/user/profile", { headers });
};

export const updateProfilePage = async (payload) => {
  return await axiosInstance.put("admin/user/update/profile", payload, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
    },
  });
};
